const NEXT_TRANSFER_TYPE = Object.freeze({
  payment: 'payment',
  refund: 'refund',
});

export default NEXT_TRANSFER_TYPE;
